import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null, showDetails: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({
            error,
            errorInfo
        });

        // TODO: Log to error tracking service (e.g., Sentry)
        // logErrorToService(error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    fontFamily: 'Inter, sans-serif'
                }}>
                    <div style={{
                        maxWidth: '600px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '40px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            fontSize: '48px',
                            marginBottom: '20px'
                        }}>⚠️</div>
                        <h1 style={{
                            fontSize: '24px',
                            color: '#1e293b',
                            marginBottom: '12px'
                        }}>
                            Ops! Algo deu errado
                        </h1>
                        <p style={{
                            color: '#64748b',
                            marginBottom: '24px',
                            lineHeight: '1.6'
                        }}>
                            Ocorreu um erro inesperado. Nossa equipe foi notificada e está trabalhando para resolver o problema.
                        </p>

                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px' }}>
                            <button
                                onClick={this.handleReset}
                                style={{
                                    backgroundColor: '#3b82f6',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px 24px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                            >
                                Recarregar Página
                            </button>

                            <button
                                onClick={() => this.setState(prev => ({ showDetails: !prev.showDetails }))}
                                style={{
                                    backgroundColor: '#cbd5e1',
                                    color: '#334155',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px 24px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                            >
                                {this.state.showDetails ? 'Ocultar Detalhes' : 'Ver Detalhes'}
                            </button>
                        </div>

                        {this.state.showDetails && this.state.error && (
                            <div style={{
                                textAlign: 'left',
                                backgroundColor: '#fee',
                                padding: '16px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                marginTop: '20px',
                                overflow: 'hidden'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <strong style={{ color: '#dc2626' }}>Erro Técnico:</strong>
                                    <button
                                        onClick={() => {
                                            const errorText = `${this.state.error.toString()}\n\n${this.state.errorInfo?.componentStack}`;
                                            navigator.clipboard.writeText(errorText);
                                            alert('Erro copiado para a área de transferência!');
                                        }}
                                        style={{
                                            fontSize: '12px',
                                            padding: '4px 8px',
                                            backgroundColor: '#fff',
                                            border: '1px solid #dc2626',
                                            borderRadius: '4px',
                                            color: '#dc2626',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Copiar Erro
                                    </button>
                                </div>
                                <pre style={{
                                    overflow: 'auto',
                                    fontSize: '12px',
                                    color: '#dc2626',
                                    maxHeight: '300px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
